import Header from './header';

export default {
  name: 'siteHeader',
  class: Header,
  querySelector: {
    drawer: '.drawer',
    drawerOpen: '.mobile-nav a.drawer-open',
  },
  querySelectorAll: {},
  options: {},
};
